import _ from 'underscore';
import { withUiBlock } from '@bingads-webui/uiblocker';

export function getInlineEditableSaveFunction(deps) {
  return ({
    view,
    i18n,
    fieldName,
    updated,
    editorView,
    editorViewCallbackAfterUpdate,
    successCallback,
  }) => {
    const toUpdate = _.pick(updated, fieldName);
    const campaignId = deps.state.get('campaign_id') || updated.CampaignId;
    const adGroupId = deps.state.get('adgroup_id') || updated.AdGroupId;
    const url = `/Customers()/Accounts()/Campaigns(${campaignId})/AdGroups(${adGroupId})/ProductGroups(${updated.Id})`;
    const patchPromise = toUpdateParam => deps.odata.patch(url, {
      data: toUpdateParam,
    }).then(() => {
      if (editorViewCallbackAfterUpdate && _.isFunction(editorViewCallbackAfterUpdate)) {
        editorViewCallbackAfterUpdate();
      }
      if (_.isFunction(successCallback)) {
        successCallback(updated);
      }
      deps.cacheManager.invalidate('ProductGroup');
      view.grid.gridView.trigger('didInlineEdit', updated);

      view.activityLogger.sendInlineEditLog(toUpdateParam);
    }).catch((response) => {
      const errorMapping = {};
      const unexpectedError = i18n.getString('ErrorNumber_-1');
      const fieldKey = _.isArray(fieldName) ? fieldName[0] : fieldName;
      if (!response || !response.errors) {
        errorMapping[fieldKey] = unexpectedError;
      } else {
        const errors = deps.getODataErrors(response.errors);

        if (!errors || !errors[0] || !errors[0].message) {
          errorMapping[fieldKey] = unexpectedError;
        } else {
          errorMapping[fieldKey] = errors[0].message;
        }
      }
      editorView.setErrors(errorMapping);

      view.activityLogger.sendInlineEditErrorLog(errorMapping);
    });

    return patchPromise(toUpdate).finally(withUiBlock(view.grid.gridView.$el));
  };
}
